import React, { useEffect, useState } from "react";
import ImageBlock from "./Blocks/ImageBlock";
import TOC from "./Blocks/TOC";
import axios from "axios";
import RichTextBlock from "./Blocks/RichTextBlock";
import VideoBlock from "./Blocks/VideoBlock";
import ReadMoreBlogsCard from "./ReadMoreBlogsCard/ReadMoreBlogsCard";
import { useLocation, useNavigate } from "react-router-dom";
import Markdown from "react-markdown";

export default function RenderContentNew() {
  const [data, setData] = useState([]);

  const [openIndex, setOpenIndex] = useState(null);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const category = pathname.includes("blogs") ? "blog" : "news";
    const fetchBlogData = async () => {
      try {
        const response = await axios.get(
          `https://admin-v1.xrealty.ae/api/articles?filters[slug][$eq]=${
            pathname?.split("/")[2]
          }&filters[category][slug][$eq]=${category}&populate[cover][populate]=*&populate[blocks][populate]=*&populate[related_blogs][populate]=*&populate[Faqs][populate]=*`
        );

        setData(response?.data?.data);
        if (response?.data?.data.length === 0) {
          if (category === "blog") navigate("/blogs/");
          else if (category === "news") navigate("/real-estate-news/");
          else navigate("/");
        }
      } catch (error) {
        console.error("Error fetching home data:", error);
        if (category === "blog") navigate("/blogs/");
        else if (category === "news") navigate("/real-estate-news/");
        else navigate("/");
      }
    };
    fetchBlogData();
  }, [navigate, pathname]);

  return (
    <>
      {data?.length === 0 ? (
        <div className="flex items-center justify-center min-h-screen bg-black">
          <div className="w-12 h-12 border-4 border-white border-dashed rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="bg-black pb-8">
          <div className="pt-28 lg:pt-48 xl:pt-48 md:pt-28 px-4 md:px-16 lg:px-32 xl:px-0 md:mx-auto xl:max-w-3xl xl:mx-auto 2xl:max-w-5xl 2xl:px-0">
            <ImageBlock imageData={data[0]?.cover} />
            {/* Title and Published Date */}
            <div className="flex flex-col gap-2">
              <h1 className="font-[optima-lt-pro] text-white uppercase text-xl md:text-2xl lg:text-3xl xl:text-3xl font-[500] mt-6 leading-7 line-clamp-3">
                {data[0]?.title}
              </h1>
              <div className="flex flex-row gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-4 text-bhagwa"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                  />
                </svg>

                <span className="font-[optima-lt-pro] text-bhagwa">
                  {new Date(data[0].published_date).toLocaleDateString()}
                </span>
              </div>
            </div>

            {data[0]?.blocks?.map((item, index) => {
              switch (item?.__component) {
                case "shared.toc":
                  return <TOC key={index} data={item?.items} />;
                case "shared.rich-text":
                  return (
                    <div key={index} className="pb-4 md:pb-8">
                      <RichTextBlock data={item?.body} />{" "}
                    </div>
                  );
                case "shared.media":
                  return (
                    <div key={index} className="py-4 md:py-8">
                      <ImageBlock imageData={item?.file} />
                    </div>
                  );
                case "shared.youtube-video":
                  return (
                    <div key={index} className="py-4 md:py-8">
                      <VideoBlock data={item?.url} />
                    </div>
                  );
                default:
                  return null;
              }
            })}
            {/* Faqs Section */}
            {data[0]?.Faqs?.length > 0 && (
              <div className="flex flex-col gap-4 mt-4">
                <h2 className="font-[optima-lt-pro] text-white font-[500] uppercase text-xl xs:text-xl md:text-3xl 2xl:text-4xl">
                  Frequently Asked Questions
                </h2>
                {/* <FAQsV1 faqs={data[0]?.Faqs} /> */}
                <div className="space-y-4 ">
                  {data[0]?.Faqs?.map((faq, index) => (
                    <div
                      key={index}
                      className="border-b border-gray-200 last:border-0"
                    >
                      <button
                        className="w-full py-4 flex justify-between items-center text-left hover:text-bhagwa transition-colors duration-300"
                        onClick={() =>
                          setOpenIndex(openIndex === index ? null : index)
                        }
                      >
                        <span className="font-[optima-lt-pro] text-white text-base md:text-lg">
                          {faq.question}
                        </span>
                        <svg
                          className={`w-5 h-5 text-bhagwa transform transition-transform duration-300 ${
                            openIndex === index ? "rotate-180" : ""
                          }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-300 ${
                          openIndex === index ? "max-h-auto pb-4" : "max-h-0"
                        }`}
                      >
                        <div
                          className="text-black  text-base md:text-base prose prose-lg prose-bhagwa max-w-none 
                              prose-headings:text-base  prose-headings:font-bold prose-headings:mb-4 prose-headings:font-[optima-lt-pro]
                              md:prose-p:text-base prose-p:font-[lato] prose-p:text-sm xl:prose-p:text-base prose-p:leading-7 prose-p:font-normal
                              prose-a:text-bhagwa prose-a:hover:underline
                              prose-strong:font-semibold prose-p:text-white
                              prose-ul:space-y-4 prose-li:font-[lato] prose-li:marker:text-white prose-li:text-white prose-li:text-sm xl:prose-li:text-base"
                        >
                          <Markdown>{faq.answer}</Markdown>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Related Blogs */}
            {data[0]?.related_blogs?.length > 0 && (
              <div className="mt-4">
                <ReadMoreBlogsCard blogsData={data[0]?.related_blogs} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
